import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import salesOpsLogo from '../assets/salesops-logo.png';
import sphereRight from '../assets/login-sphere-right.png';
import './Login.css';

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/Users/ForgotPassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      // Güvenlik gereği yanıt her durumda başarılı; e-postanın varlığını sızdırmıyoruz.
      if (res.ok) {
        setDone(true);
      } else {
        const text = await res.text();
        setError(text || 'İşlem başarısız. Lütfen tekrar deneyin.');
      }
    } catch {
      setError('Bağlantı hatası. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-screen" role="main" aria-label="Şifremi Unuttum">
      <div className="login-bg" aria-hidden="true">
        <div className="login-orb-left" />
      </div>

      <div className="login-stage">
        <div className="login-brand" aria-hidden="true">
          <img className="login-brand-logo" src={salesOpsLogo} alt="SalesOps" />
          <small className="login-brand-tag">SALES OPERATIONS WORKSTATION</small>
        </div>

        <div className="login-cardbox">
          <img className="login-orb-right" src={sphereRight} alt="" aria-hidden="true" />
          <div className="login-card">
            <img className="login-logo" src={salesOpsLogo} alt="SalesOps" />

            <header className="login-card-head">
              <h1>Şifremi Unuttum</h1>
              <p>Hesabınıza kayıtlı e-posta adresini girin; size sıfırlama bağlantısı gönderelim.</p>
            </header>

          {done ? (
            <div className="login-foot">
              <div className="login-msg" aria-live="polite">
                Eğer bu e-posta sistemde kayıtlıysa, şifre sıfırlama bağlantısı gönderildi.
                Lütfen gelen kutunuzu (ve spam klasörünü) kontrol edin.
              </div>
              <div style={{ marginTop: 16, textAlign: 'center' }}>
                <a className="login-link" href="#" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
                  Giriş ekranına dön
                </a>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} autoComplete="on">
              <div className="login-field">
                <label htmlFor="fp-email">E-posta</label>
                <div className="login-input">
                  <input
                    id="fp-email"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="username"
                    placeholder="ornek@firma.com"
                    required
                  />
                </div>
              </div>

              <button type="submit" className="login-submit" disabled={loading}>
                {loading ? 'Gönderiliyor...' : 'Sıfırlama Bağlantısı Gönder'}
              </button>

              <div className="login-foot">
                <div className="login-msg" aria-live="polite">{error}</div>
                <div style={{ marginTop: 12, textAlign: 'center' }}>
                  <a className="login-link" href="#" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
                    Giriş ekranına dön
                  </a>
                </div>
              </div>
            </form>
          )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default ForgotPasswordPage;
